import { echartLine } from '../common';
import { createLeafletMap, obtenerGeoJson } from '../common-leafletMap';

export function mapPuntosMedidaTrafico(vis, datos) {
  document
    .querySelector('#tabPuntsMesuraCiutat')
    .addEventListener('click', () => {
      requestAnimationFrame(() => {
        createLeafletMap(
          'idMapPuntsMesuraCiutat',
          5,
          20,
          14,
          obtenerGeoJson(datos.resultset, 0, 1, 3),
          'build/images/mapas/marker-icon-vehiculos.svg/content',
          'build/images/mapas/marker-icon-selected-vehiculos.svg/content',
          'puntoMedidaLaneId',
        );
      });
    });
}

export function echartPuntosMedidaTrafico(vis, datos) {
  echartLine(
    datos,
    true,
    -6,
    'TRÀNSIT DE VEHICLES: PUNTS DE MESURA DE LA CIUTAT',
    'Vehicles',
    'chartPuntsMesuraCiutat',
    'no_dataPuntsMesuraCiutat',
  );
}
